export interface HeroSelectable {
    heros?: number[]
    activeHeroID?: number
}

// 登录后的默认英雄 = 后端暴露的"激活英雄"（activeHeroID），不是前端自己取 heros[0]。
// 后端语义：第一个创建的英雄被 SetActive(true)（usersys/user.go NewHero），响应时动态
// 计算（usersys/service.go withActiveHeroID）。无激活英雄（零英雄）返回 null。
export function getDefaultHeroId( user: HeroSelectable ): string | null {
    if ( !user.activeHeroID ) {
        return null
    }
    return String( user.activeHeroID )
}
